

























import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import icon from 'components/presenter/item/ItemIcon'
import api from 'src/assets/api/gql'
import AttendeeItemChildren from 'src/graphql/attendee_item/AttendeeItemChildren.gql'
import { Item, AttendeeItem } from 'src/graphql/types'

@Component
export default class AttendeeItemCourse extends Vue {
  icon = icon
  loading = false
  topics: AttendeeItem[] = []

  @Prop()
  readonly item!: Item

  async refresh (done: () => void) {
    this.loading = true
    this.topics = []
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    const { data: { attendeeItemChildren } } = await api.query({
      query: AttendeeItemChildren,
      variables: {
        id: this.item.id
      }
    })
    this.loading = false
    if (attendeeItemChildren) {
      this.topics = attendeeItemChildren.nodes as AttendeeItem[]
    }
    done(true)
  }
}
